import React from 'react';
import { Button, Modal } from '../ui';
import DeleteConfirmationDialogWrapper from './DeleteConfirmationDialog.style';

const DeleteConfirmationDialog = ({
  children,
  onCancel,
  onSubmit,
  show,
  title,
  width = 600,
  confirmationButtonLabel = 'Löschen',
  cancelButtonLabel = 'Abbrechen',
  ...restProps
}) => {
  const footer = (
    <DeleteConfirmationDialogWrapper>
      <div className="delete-confirmation-footer">
        <Button type="secondary" onClick={onCancel}>
          {cancelButtonLabel}
        </Button>
        <Button onClick={onSubmit} danger>
          {confirmationButtonLabel}
        </Button>
      </div>
    </DeleteConfirmationDialogWrapper>
  );

  return (
    <Modal
      footer={footer}
      mask={{ closable: true }}
      onCancel={onCancel}
      title={title}
      width={width}
      open={show}
      {...restProps}
      centered
      className="centered-modal"
    >
      {children}
    </Modal>
  );
};

export default DeleteConfirmationDialog;
